import { render } from "./pay-settings.vue?vue&type=template&id=e37db180&scoped=true&ts=true"
import script from "./pay-settings.vue?vue&type=script&lang=ts"
export * from "./pay-settings.vue?vue&type=script&lang=ts"

import "./pay-settings.vue?vue&type=style&index=0&id=e37db180&scoped=true&lang=scss"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e37db180"]])